import { Navigate, useParams } from "react-router-dom";

import { CustomizationDemandExcelDetailFeaturePage } from "../ui/CustomizationDemandExcelDetailFeaturePage";

/** 需求版本 Excel 详表只读页路由入口。 */
export function CustomizationDemandExcelDetailPage() {
  const params = useParams();
  const projectId = params.projectId?.trim() ?? "";
  const demandId = params.demandId?.trim() ?? "";

  if (!projectId || !demandId) {
    return <Navigate to="/crm/customization/projects" replace />;
  }

  return <CustomizationDemandExcelDetailFeaturePage projectId={projectId} demandId={demandId} />;
}
